import { jsx as _jsx } from "react/jsx-runtime";
import { FormGroupStyled } from './FormGroup.styled';
const FormGroup = (props) => {
    return _jsx(FormGroupStyled, { ...props });
};
export { FormGroup };
